import { render, staticRenderFns } from "./listShopInvoiceDetail.vue?vue&type=template&id=5d5197f2"
import script from "./listShopInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./listShopInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./listShopInvoiceDetail.vue?vue&type=style&index=0&id=5d5197f2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports